import React from "react";
import axios from "axios";
import Spinner from "./../../components/Spinner";
import { Modal } from "../../components/Modal";

const API = localStorage.getItem("assethost");

export default class AccountStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: false,
      msg: "",
      toastColor: "",
      time: new Date(),
      accountStatus: null,
      fullname: window.sessionStorage.getItem("fullname"),

      // Subscription form fields
      showAddModal: false,
      subscriptionId: "",
      paymentMethod: "",
      dueDate: "",
      fee: "",
      status: "",

      // POP upload fields
      showPopModal: false,
      selectedSubscriptionId: "",
      popFile: null,

      // Show POPs modal fields
      showPopsModal: false,
      popsList: [],

      // Dropdown data
      subscriptionsList: [],
      paymentMethods: [],

      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchAccountStatus = this.fetchAccountStatus.bind(this);
    this.fetchDropdowns = this.fetchDropdowns.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.uploadPop = this.uploadPop.bind(this);
    this.openPopModal = this.openPopModal.bind(this);
    this.refreshStatus = this.refreshStatus.bind(this);
    this.fetchPops = this.fetchPops.bind(this);
    this.openPopsModal = this.openPopsModal.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.fetchDropdowns(token);
    this.fetchAccountStatus(token);
  }

  fetchAccountStatus(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });

    const companyProfileId = window.sessionStorage.getItem("companyProfileId");
    if (!companyProfileId) {
      this.setState({
        loading: false,
        msg: "Logged in account is not a company account",
        toastColor: "danger",
      });
      return;
    }

    axios
      .get(API + `/billing/getaccountstatus/${companyProfileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        this.setState({
          accountStatus: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
        });
      });
  }

  fetchDropdowns(token) {
    axios
      .get(API + "/billing/getallsubscriptions", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          subscriptionsList: data || [{ id: 0, name: "Test" }],
          paymentMethods: data.paymentMethods || [],
        });
      })
      .catch((error) => {
        console.error("Failed to load dropdowns:", error);
      });
  }

  refreshStatus() {
    this.setState({ time: new Date() }, () => {
      const token = sessionStorage.getItem("token");
      if (token) {
        this.fetchAccountStatus(token);
      }
    });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file });
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.subscriptionId) {
      errors.subscriptionName = "Subscription is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      subscriptionId: this.state.subscriptionId,
      companyProfileId: Number(sessionStorage.getItem("companyProfileId")),
    };

    axios
      .post(API + "/billing/subscribe", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Subscription added successfully!",
            toastColor: "success",
            loading: false,
            showAddModal: false,
            valid: false,
            errors: {},
          });
          setTimeout(() => {
            this.fetchAccountStatus(token);
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Failed to add subscription",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to add subscription. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  openPopModal(subscriptionId) {
    this.setState({
      showPopModal: true,
      selectedSubscriptionId: subscriptionId,
      popFile: null,
      msg: "",
    });
  }

  uploadPop(e) {
    e.preventDefault();

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    if (!this.state.popFile) {
      this.setState({
        msg: "Please select a POP file to upload.",
        toastColor: "danger",
      });
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append("popFile", this.state.popFile);
    request.append("subscriptionId", this.state.selectedSubscriptionId);
    request.append(
      "companyProfileId",
      Number(sessionStorage.getItem("companyProfileId"))
    );

    axios
      .post(API + "/billing/uploadpop", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "POP uploaded successfully!",
            toastColor: "success",
            loading: false,
            showPopModal: false,
            popFile: null,
            selectedSubscriptionId: "",
          });
          setTimeout(() => {
            this.fetchAccountStatus(token);
          }, 5000);
        } else {
          this.setState({
            msg: response.data.message || "Failed to upload POP",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to upload POP. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  fetchPops() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    const companyProfileId = window.sessionStorage.getItem("companyProfileId");
    if (!companyProfileId) {
      this.setState({
        msg: "Company Profile ID not found",
        toastColor: "danger",
      });
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/billing/getmypopsbyid/${companyProfileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        this.setState({
          popsList: response.data || [],
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to fetch POPs",
          toastColor: "danger",
        });
      });
  }

  openPopsModal() {
    this.setState({
      showPopsModal: true,
      msg: "",
    });
    this.fetchPops();
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen w-full flex flex-col overflow-y-auto">
        {divMsg}
        <div className="grow px-5 flex flex-col items-center">
          {!s.accountStatus || !s.accountStatus.subscriptionName ? (
            // No account status - show Add Subscription button
            <div className="flex gap-4 mt-2 mb-4 w-full justify-start">
              <button
                className="btn btn-success"
                onClick={() =>
                  this.setState({
                    showAddModal: true,
                    msg: "",
                    subscriptionId: "",
                  })
                }
              >
                Add Subscription
              </button>
            </div>
          ) : (
            // Has account status - show account details and Upload POP button
            <>
              <div className="w-full flex justify-start">
                <button
                  className="btn btn-success"
                  onClick={this.openPopsModal}
                >
                  Show POPs
                </button>
              </div>
              <div className="w-full overflow-x-auto border mt-2">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Account Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Subscription Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Cost
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Expiry Date
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200 overflow-y-auto">
                    <tr className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {s.fullname || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {s.accountStatus.subscriptionName || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {s.accountStatus.cost || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {s.accountStatus.expiryDate || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {s.accountStatus.companyAccountActive || "Inactive"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 space-x-2">
                        <button
                          className="btn btn-success w-fit px-2"
                          onClick={this.refreshStatus}
                        >
                          Refresh status{" "}
                          <i
                            className="bi bi-arrow-clockwise"
                            style={{ color: "white" }}
                          />
                        </button>
                        <button
                          className="btn btn-success"
                          onClick={() =>
                            this.openPopModal(s.accountStatus.subscriptionId)
                          }
                        >
                          Upload POP
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>

        {/* Add Subscription Modal */}
        {s.showAddModal && (
          <Modal
            title="Add New Subscription"
            closeAction={() => this.setState({ showAddModal: false })}
            footerContent={
              <>
                {s.valid && (
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={s.loading}
                    form="subscriptionForm"
                  >
                    Save
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      showAddModal: false,
                      subscriptionName: "",
                      paymentMethod: "",
                      dueDate: "",
                      fee: "",
                      status: "",
                      valid: false,
                      errors: {},
                    })
                  }
                >
                  Close
                </button>
              </>
            }
          >
            <form
              id="subscriptionForm"
              onSubmit={this.handleSave}
              className="space-y-4"
              autoComplete="off"
            >
              {divMsg}
              <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text required">
                    Subscription
                  </label>
                  <select
                    name="subscriptionId"
                    className={`form-control ${
                      s.errors.subscriptionId ? " !border-red-500" : ""
                    }`}
                    value={s.subscriptionId}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {s.subscriptionsList.map((subscription) => (
                      <option
                        key={`subscription-${subscription.id}`}
                        value={subscription.id}
                      >
                        {subscription.name}
                      </option>
                    ))}
                  </select>
                  {s.errors.subscriptionName && (
                    <span className="input-group-error">
                      {s.errors.subscriptionName}
                    </span>
                  )}
                </div>
              </div>
            </form>
          </Modal>
        )}

        {/* Upload POP Modal */}
        {s.showPopModal && (
          <Modal
            title="Upload POP"
            closeAction={() =>
              this.setState({ showPopModal: false, popFile: null })
            }
            footerContent={
              <>
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={s.loading || !s.popFile}
                  onClick={this.uploadPop}
                >
                  {s.loading ? "Uploading..." : "Upload"}
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      showPopModal: false,
                      popFile: null,
                      selectedSubscriptionId: "",
                    })
                  }
                >
                  Cancel
                </button>
              </>
            }
          >
            <form onSubmit={this.uploadPop} className="space-y-4">
              <div className="input-group">
                <label className="input-group-text">POP File</label>
                <input
                  name="popFile"
                  className="form-control"
                  type="file"
                  onChange={this.handleFileChange}
                  accept=".pdf,image/*"
                  required
                />
              </div>
              <div className="text-sm text-gray-600">
                Please upload a PDF or image file of your proof of payment.
              </div>
            </form>
          </Modal>
        )}

        {/* Show POPs Modal */}
        {s.showPopsModal && (
          <Modal
            title="My POPs"
            closeAction={() =>
              this.setState({ showPopsModal: false, popsList: [] })
            }
            footerContent={
              <button
                type="button"
                className="btn btn-success"
                onClick={() =>
                  this.setState({
                    showPopsModal: false,
                    popsList: [],
                  })
                }
              >
                Close
              </button>
            }
          >
            <div className="w-full">
              {s.loading ? (
                <div className="flex justify-center py-4">
                  <Spinner className="" />
                </div>
              ) : s.popsList.length === 0 ? (
                <div className="text-center py-4 text-gray-500">
                  No POPs found
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          POP File ID
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Message
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Creation Date
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {s.popsList.map((pop, index) => (
                        <tr key={pop.id || index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {pop.popFileId || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            <span
                              className={`px-2 py-1 rounded-full text-xs font-medium ${
                                pop.popStatus === "APPROVED"
                                  ? "bg-green-100 text-green-800"
                                  : pop.popStatus === "PENDING"
                                  ? "bg-yellow-100 text-yellow-800"
                                  : pop.popStatus === "REJECTED"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {pop.popStatus || "Unknown"}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-900">
                            {pop.message || "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            {pop.creationDateTime
                              ? new Date(pop.creationDateTime).toLocaleString()
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </Modal>
        )}
      </div>
    );
  }
}
